// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.painel {
    position: sticky;
    /* top: 10px; */
    background-color: black;
    /* Defina uma cor de fundo, se necessário */
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Estimativa/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,2CAA2C;IAC3C,YAAY;AAChB","sourcesContent":[".painel {\n    position: sticky;\n    /* top: 10px; */\n    background-color: black;\n    /* Defina uma cor de fundo, se necessário */\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
